import type { TemplateMessageItem } from '@/models/welcomeTextInboxCaller';

export const welcomeSmsText = `Hi {customerFirstName}, this is {operatorFirstName} from the member experience team at Gogo. I saw you took your first ride with us yesterday and wanted to check in. How did your ride go?`;
export const positiveSmsText = "I'm so glad to hear that! Do you ever have trouble getting groceries, especially heavier items?";
export const neutralSmsText = 'Is there something we can do better next time?';
export const groceryPricingSmsText =
  'Grocery ordering is already included in your membership, you pay just for the items and a small per item fee. Your fee per order starts from $7 and is capped at ${groceryMaxCharge} for very large orders. Would you like a $5 discount on your first order?';

export const welcomeTemplates: TemplateMessageItem[] = [
  { subject: 'Welcome', message: welcomeSmsText },
  { subject: 'Neutral Reply', message: neutralSmsText },
  { subject: 'Positive Reply', message: positiveSmsText },
  {
    subject: 'Positive Reply with Phone Number',
    message:
      "Thank you so much for your feedback and for choosing GoGoGrandparent. If you need any assistance in the future, please don't hesitate to contact us at 855-464-6872 | 24/7. Have a wonderful day! 😊",
  },
  {
    subject: 'Positive Reply with Survey',
    message:
      "I'm so glad to hear that! To make sure we can meet all of your needs on your future rides, could you please tell us a bit about yourself in this welcome questionnaire?\nhttps://gogograndparent.formstack.com/forms/welcome_survey 😊",
  },
  {
    subject: 'Wants to Schedule a Ride',
    message:
      'Of course! Can you please provide the pickup and destination address and pickup time? That way, I can provide you with an estimate for your ride. 😊',
  },
  {
    subject: 'Negative Reply Request More Info',
    message:
      "Could you please share a little more about what happened or what didn't meet your expectations? We want to make sure we're doing everything we can to support you properly. 😊",
  },
  {
    subject: 'Ride Price',
    message:
      'Thank you so much for sharing that information with me. For future ride requests, please dial "0" to speak with an operator. You may ask for the cheapest ride available, and the operator will be more than happy to help you.\nDistance, time, and ride demand are the factors we take into consideration when providing an estimate.\nIf you need any assistance in the future, please don\'t hesitate to contact us at 855-464-6872. This line is available 24/7. Have a wonderful day! 😊',
  },
  {
    subject: 'Positive Driver Feedback',
    message:
      "Hi {customerFirstName}! I'm so happy to hear you had such a great experience. I'll be sure to share that positive feedback with your driver—I know it will make their day!",
  },
  {
    subject: 'Wrap-up',
    message:
      "Thank you so much for taking the time to share your feedback; we truly appreciate it. If you need anything else, please don't hesitate to call us 24/7 at 855-464-6872. Have a wonderful day! 😊",
  },
  {
    subject: 'Explain Membership',
    message:
      "The membership gives you access to our team of 24/7 operators to assist you with rides, deliveries, and more. We monitor every ride to make sure you're taken care of and whenever you have questions there is always a real person available to help at 855-464-6872.",
  },
  {
    subject: 'Round Trip',
    message:
      "Thank you for letting me know. We offer one-way trips, and when you're ready to return you can simply give us a call or text back \"ready\" to be picked up. We'll dispatch a new driver within a few minutes. This means that you can take your time at your destination and that you don't need to pay a driver to wait for you.",
  },
  {
    subject: 'How To Order Rides via Text',
    message:
      'To order your next ride, text back "ride" to the last message from us or call +18554646872.\nAn automated process will collect your pickup and drop-off addresses from saved locations or via a typed address.\nYou can select from Home or your saved locations.\nYou can also type an address or business name, and we will return results that are close to your home address to select from\nWe send a ride estimate.\nUpon confirmation, we order the ride automatically.',
  },
  {
    subject: 'Asked to Cancel',
    message:
      "I completely understand, and thank you for sharing that with me. I'm really glad we could help when you needed it. If you'd like to cancel your membership, you can call our main number at 855-464-6872 and our team will take care of it for you. We'd be happy to help again in the future whenever the timing is right. Wishing you a wonderful day.",
  },
  {
    subject: 'Insisted on Cancelling',
    message:
      'Thank you for letting us know, {customerFirstName}. A supervisor will contact you shortly to assist with canceling your GoGoGrandparent membership.',
  },
  {
    subject: 'Monitoring',
    message:
      "Thank you for sharing the feedback! To make sure everything continues to go smoothly, we'll go ahead and activate our monitoring team on your account, so your rides are monitored 24/7 moving forward. This helps us stay on top of things and avoid any future issues. Please don't hesitate to reach out if you ever need anything—we're here to help.",
  },
  {
    subject: 'Driver Complaint',
    message:
      "Thank you for bringing this to our attention, {customerFirstName}. I sincerely apologize for the driver's behavior, as this does not reflect the standards of service we strive to provide. Your feedback is greatly appreciated, and we will ensure that this matter is reviewed appropriately. Please let us know if there is anything further we can assist you with.",
  },
  {
    subject: 'Scheduled Ride Monitoring',
    message:
      "I sincerely apologize, especially since this was your first scheduled ride with us and this situation caught you off guard. To help prevent this from happening in the future, I will request our monitoring team to keep a close eye on your upcoming rides. They will contact you if there are any pricing changes or if the driver has any difficulty locating you. This will shorten the pickup wait time and you won't have to go through this situation again.",
  },
  {
    subject: 'Free Ride',
    message:
      'As an apology for the inconvenience, I would like to offer you 1 FREE RIDE. This promotion is valid for a ride up to 5 miles and can be used at a time that works best for you.',
  },
  { subject: 'Signed Up Just in Case', message: "Great, we're here when you need us! Just give us a call at 855-464-6872 anytime." },
  {
    subject: 'Grocery Pitch',
    message:
      'That makes sense. Your GoGo membership gives you access to our grocery delivery service too! Just call us, tell an operator what you’d like and we’ll have someone shop for you and deliver it to your home. Would you like to try it?',
  },
  {
    subject: 'Uses Alternative Grocery Delivery Service',
    message:
      "Great, I'm glad {Walmart+} works for you! If you'd ever prefer to order from a different store or order over the phone instead of online, we'd be happy to help as well.",
  },
  {
    subject: 'Bad Gourmet Meal',
    message:
      "I'm so sorry your meal didn't meet your expectations! We partner with many more local restaurants and would be happy to offer you $5 off your next order if you'd like to try something different.",
  },
];
